// 0) Make sure Font Awesome 4 CSS is included once in your app (e.g., public/index.html):
// <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css">

import * as React from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import react, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';

import { Drawer, Descriptions, Divider, Tag } from 'antd';
import { authHeaders,getSessionToken } from "../utils/session";


const items = [
    { label: 'All Good', count: 39, icon: 'fa fa-check-circle', bg: '#28a745', hover: '#218838' },
    { label: 'Qualified', count: 22, icon: 'fa fa-star', bg: '#007bff', hover: '#0069d9' },
    { label: 'Hot Leads', count: 12, icon: 'fa fa-fire', bg: '#dc3545', hover: '#c82333' },
    { label: 'Call Back', count: 7, icon: 'fa fa-phone', bg: '#ffc107', hover: '#e0a800', darkText: true },
    { label: 'Price Issue', count: 3, icon: 'fa fa-money', bg: '#fd7e14', hover: '#e5670c' },
    { label: 'Hired Someone', count: 0, icon: 'fa fa-user-times', bg: '#6f42c1', hover: '#5a32a3' },
    { label: 'Not Interested', count: 1, icon: 'fa fa-ban', bg: '#6c757d', hover: '#5a6268' },
    { label: 'Meeting', count: 4, icon: 'fa fa-handshake-o', bg: '#17a2b8', hover: '#138496' },
    { label: 'Language Barrier', count: 3, icon: 'fa fa-language', bg: '#20c997', hover: '#17a589' },
    { label: 'Not Responding', count: 1, icon: 'fa fa-volume-off', bg: '#6610f2', hover: '#520dc2' },
    { label: 'Not Eligible', count: 1, icon: 'fa fa-times-circle', bg: '#d63384', hover: '#b02a6f' },
    { label: 'Today Follow-ups', count: 0, icon: 'fa fa-calendar-check-o', bg: '#198754', hover: '#146c43' },
    { label: 'Total Pipeline Value', count: '166688.35', icon: 'fa fa-line-chart', bg: '#0dcaf0', hover: '#0bb8de', darkText: true },
    { label: 'Pending Payments', count: 40, icon: 'fa fa-credit-card', bg: '#ff4d4d', hover: '#e63c3c' },
];


<style>{`
    @keyframes pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.5; }
    }
    
    .table-hover tbody tr:hover {
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
    
    .form-check-input:checked {
      background-color: #667eea;
      border-color: #667eea;
    }
    
    .badge {
      transition: all 0.2s ease;
    }
  `}</style>

// Small helper so every button shows: [icon] [label] [count]
const Content = ({ icon, label, count, darkText }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 1 }}>
        <i className={icon} style={{ fontSize: 18 }} />
        <Typography
            component="span"
            sx={{
                fontWeight: 600,
                flexGrow: 1,
                fontSize: 12,
                mx: 1,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                color: darkText ? '#111' : 'inherit',
            }}
        >
            {label}
        </Typography>
        <Box
            component="span"
            sx={{
                fontWeight: 700,
                fontSize: 14,
                elevation: 8,
                px: 1.25,
                py: 0.25,
                borderRadius: '12px',
                lineHeight: 1.6,
                bgcolor: darkText ? 'rgba(0,0,0,0.08)' : 'rgba(255,255,255,0.22)',
                color: darkText ? '#111' : '#fff',
            }}
        >
            {count}
        </Box>
    </Box>
);

const LeadInbox = () => {

    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const [userList, setUserList] = useState([]);
    const [totalLeads, setTotalLeads] = useState(0);


    const [detailOpen, setDetailOpen] = useState(false);
    const [detailSize, setDetailSize] = useState('large');
    const [detailLoading, setDetailLoading] = useState(false);
    const [selectedLead, setSelectedLead] = useState(null);



    const handleViewDetails = async (id) => {
        setDetailSize('large');          // we always want large drawer
        setDetailOpen(true);             // open drawer
        setDetailLoading(true);          // show loading state
        setSelectedLead(null);           // reset previous data

        try {
            const token = getSessionToken();

            // Adjust path if API_BASE_URL already includes /api or not
            const response = await axios.get(
                `${API_BASE_URL}/trademark-enquiries-details/${id}`,
                {
                    headers: {
                        ...authHeaders(),
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data?.status === 200 && response.data.data) {
                setSelectedLead(response.data.data);
            } else {
                console.warn("Unexpected detail response:", response.data);
                setSelectedLead(null);
            }
        } catch (error) {
            console.error("Error fetching lead details:", error);
            setSelectedLead(null);
        } finally {
            setDetailLoading(false);
        }
    };




    useEffect(() => {
        const fetchUserList = async () => {
            try {
                const token = getSessionToken();
                console.log("Fetching internal users...");

                const response = await axios.get(`${API_BASE_URL}/get-internal-user-list`, {
                    headers: {
                        ...authHeaders(),
                        "Content-Type": "application/json",
                    },
                });

                if (response.data?.status === 200) {
                    console.log("✅ Internal User List:", response.data.data);
                    setUserList(response.data.data);
                } else {
                    console.warn("⚠️ Unexpected response:", response.data);
                    setUserList([]);
                }
            } catch (error) {
                console.error("❌ Error fetching internal users:", error);
                setUserList([]);
            }
        };

        fetchUserList();
    }, []);




    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = getSessionToken();
                console.log("Token:", token);

                const response = await axios.get(`${API_BASE_URL}/get-trademark-enquiries`, {
                    params: { page: currentPage, limit: 10 },
                    headers: {
                        ...authHeaders(),
                        "Content-Type": "application/json",
                    },
                });

                const apiData = Array.isArray(response.data.data) ? response.data.data : [];
                setRows(apiData);

                setTotalLeads(response.total_records || response.data.pagination.total_records || 0);

                console.log("All List", response)
                console.log("Total Lead", totalLeads)

                // ✅ extract pagination info
                const { pagination } = response.data;
                setTotalPages(pagination?.total_pages || 1);

                console.log("📄 Current Page:", pagination?.current_page);
                console.log("📊 Total Pages:", pagination?.total_pages);
                console.log("📦 API Data:", apiData);
            } catch (error) {
                console.error("Error fetching data:", error);
                setRows([]);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [currentPage]);


    const formatDate = (dateStr) => {
        if (!dateStr) return 'N/A';
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <Stack spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap sx={{ flexWrap: 'wrap', mb: 4 }}>
                        {items.map((it) => (
                            <Button
                                key={`soft-${it.label}`}
                                href="#"
                                variant="contained"
                                sx={{
                                    minWidth: 220,
                                    px: 2,
                                    py: 1.25,
                                    borderRadius: '14px',
                                    textTransform: 'none',
                                    justifyContent: 'flex-start',
                                    backgroundColor: `${it.bg}22`,
                                    color: it.bg,
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                                    border: `1px solid ${it.bg}55`,
                                    transition: 'box-shadow 160ms ease, transform 160ms ease, background-color 160ms ease',
                                    '&:hover': {
                                        backgroundColor: `${it.bg}33`,
                                        transform: 'translateY(-1px)',
                                        boxShadow: '0 8px 20px rgba(0,0,0,0.10)',
                                    },
                                }}
                            >
                            <Content icon={it.icon} label={it.label} count={it.count} darkText />
                            </Button>
                        ))}
                    </Stack>
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Manage Lead Inbox</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item">
                                            <a href="javascript: void(0);">CMS</a>
                                        </li>
                                        <li className="breadcrumb-item active">Manage Lead Inbox</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-body rounded-3">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="col-md-7">
                                            <h4 className="card-title mb-4">Lead Inbox Filters ({totalLeads}) </h4>
                                        </div>
                                        <div className="col-md-3">
                                            <input type="text" className="form-control" placeholder="Search here..." />
                                        </div>
                                        <div className="col-md-2">
                                            <button type="button" className="btn btn-primary search">
                                                Search<i className="fa fa-search ms-1" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-body rounded-3">
                                        <div className="row g-3 mb-3">
                                            <div className="col-md-3">
                                                <label className="form-label">Date</label>
                                                <input type="date" className="form-control" placeholder="Enter Date" />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label">To</label>
                                                <input type="date" className="form-control" placeholder="Enter Date" />
                                            </div>

                                            <div className="col-md-3">
                                                <label className="form-label">Assign To</label>
                                                <select className="form-select">
                                                    <option value="">All</option>
                                                    <option value="0" defaultValue>Admin</option>
                                                    <option value="1">John Doe</option>
                                                    <option value="2">Alex Smith</option>
                                                </select>
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label">Name</label>
                                                <input type="text" className="form-control" placeholder="Enter Name" />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label">Phone</label>
                                                <input type="tel" className="form-control" placeholder="Enter Phone" />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label">Email</label>
                                                <input type="email" className="form-control" placeholder="Enter Email" />
                                            </div>

                                            <div className="col-md-3">
                                                <label className="form-label">Lead ID</label>
                                                <input type="number" className="form-control" placeholder="Enter Lead ID" />
                                            </div>

                                            <div className="col-md-3">
                                                <label className="form-label">Lead Power</label>
                                                <select className="form-select">
                                                    <option value="">All</option>
                                                    <option value="0" defaultValue>High</option>
                                                    <option value="1">Medium</option>
                                                    <option value="2">Low</option>
                                                </select>
                                            </div>

                                            <div className="col-md-3 mt-4">
                                                <button className="btn btn-success mt-3 me-2">
                                                    <i className="fa fa-search me-1" /> Search
                                                </button>
                                            </div>
                                        </div>
                                        <div className="row g-3 mb-3">
                                            <div className="col-md-3">
                                                <label className="form-label">Follow Up Date</label>
                                                <select className="form-select">
                                                    <option value="">All</option>
                                                    <option value="0" defaultValue>Today</option>
                                                    <option value="1">Tomorrow</option>
                                                    <option value="2">This Week</option>
                                                </select>
                                            </div>

                                            <div className="col-md-3">
                                                <label className="form-label">Confidence%</label>
                                                <select className="form-select">
                                                    <option value="">All</option>
                                                    <option value="0" defaultValue>High</option>
                                                    <option value="1">Medium</option>
                                                    <option value="2">Low</option>
                                                </select>
                                            </div>

                                            <div className="col-md-3">
                                                <label className="form-label">Pipeline</label>
                                                <select className="form-select">
                                                    <option value="">All</option>
                                                    <option value="0" defaultValue>High</option>
                                                    <option value="1">Medium</option>
                                                    <option value="2">Low</option>
                                                </select>
                                            </div>
                                            <div className="col-md-3 mt-4">
                                                <button className="btn btn-success mt-3 me-2">
                                                    <i className="fa fa-filter me-1" /> Filter
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card">
                                <div className="card-body rounded-3">
                                    <h4 className="card-title mb-4">Enquiry List - ({totalLeads})</h4>
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <div className="mb-2">
                                            <a href="#" className="btn btn-success">
                                                Add Enquiry <i className="fa fa-plus ms-1" />
                                            </a>
                                            <a href="#" className="btn btn-primary ms-2">
                                                Delete Selected <i className="fa fa-trash ms-1" />
                                            </a>
                                            <a href="#" className="btn btn-primary ms-2">
                                                Import <i className="fa fa-upload ms-1" />
                                            </a>
                                            <a href="#" className="btn btn-secondary ms-2">
                                                Export <i className="fa fa-download ms-1" />
                                            </a>
                                        </div>
                                        <div className="mb-2">
                                            <div className="btn-group" role="group" aria-label="Button group with nested dropdown">

                                                <div className="btn-group dropstart" role="group">
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-secondary text-dark dropdown-toggle"
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="false"
                                                    >
                                                        Assign To <i className="fa fa-chevron-down text-dark mx-2"></i>
                                                    </button>

                                                    <ul className="dropdown-menu">
                                                        {userList.length > 0 ? (
                                                            userList.map((user) => (
                                                                <li key={user.id}>
                                                                    <a className="dropdown-item d-flex align-items-center" href="#">
                                                                        <i className="fa fa-user-circle text-primary me-2"></i>
                                                                        <div>
                                                                            <div style={{ fontWeight: 600, fontSize: "13px" }}>{user.name}</div>
                                                                            <div style={{ fontSize: "11px", color: "#6b7280" }}>{user.email}</div>
                                                                        </div>
                                                                    </a>
                                                                </li>
                                                            ))
                                                        ) : (
                                                            <li>
                                                                <span className="dropdown-item text-muted">No users found</span>
                                                            </li>
                                                        )}
                                                    </ul>
                                                </div>
                                                <button type="button" className="btn btn-success">Allocate <i className="fa fa-check ms-1"></i></button>

                                            </div>

                                        </div>
                                    </div>

                                    <div className="table-responsive shadow-lg rounded-4 border-0 overflow-hidden" style={{ background: 'linear-gradient(to bottom, #ffffff, #f8f9fa)' }}>
                                        <table className="table align-middle mb-0 table-hover">
                                            <thead style={{
                                                background: 'linear-gradient(135deg, rgb(204 135 76) 0%, rgb(204 135 76 / 87%) 100%)',
                                                position: 'sticky',
                                                top: 0,
                                                zIndex: 10
                                            }}>
                                                <tr>
                                                    <th className="text-center py-3 text-white border-0">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            style={{
                                                                width: '18px',
                                                                height: '18px',
                                                                cursor: 'pointer',
                                                                accentColor: '#fff'
                                                            }}
                                                        />
                                                    </th>
                                                    <th className="py-3 text-white border-0 fw-semibold">User</th>
                                                    <th className="py-3 text-white border-0 fw-semibold">Lead Details</th>
                                                    <th className="py-3 text-white border-0 fw-semibold">Source Info</th>
                                                    <th className="py-3 text-white border-0 fw-semibold">Message</th>
                                                    <th className="py-3 text-white border-0 fw-semibold">Status</th>
                                                    <th className="py-3 text-white border-0 fw-semibold">Date</th>
                                                    <th className="py-3 text-white border-0 fw-semibold text-center">Actions</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {loading ? (
                                                    [...Array(5)].map((_, i) => (
                                                        <tr key={i}>
                                                            <td colSpan="8" className="p-0">
                                                                <Skeleton height={60} style={{ margin: '4px 0' }} />
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : rows.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="8" className="text-center py-5">
                                                            <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '300px' }}>
                                                                <div
                                                                    className="rounded-circle d-flex align-items-center justify-content-center mb-3"
                                                                    style={{
                                                                        width: '80px',
                                                                        height: '80px',
                                                                        background: 'linear-gradient(135deg, #667eea20, #764ba220)',
                                                                        border: '3px solid #667eea30'
                                                                    }}
                                                                >
                                                                    <i className="fa fa-inbox text-muted" style={{ fontSize: 32 }} />
                                                                </div>
                                                                <h5 className="text-muted mb-2">No Enquiries Found</h5>
                                                                <p className="text-muted small">Try adjusting your filters or search criteria</p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    rows.map((item, index) => (
                                                        <tr
                                                            key={item?.id || index}
                                                            className="align-middle border-bottom"
                                                            style={{
                                                                backgroundColor: index % 2 === 0 ? "#ffffff" : "#fafbfc",
                                                                transition: "all 0.3s ease",
                                                                cursor: "pointer"
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.currentTarget.style.backgroundColor = "#f0f4ff";
                                                                e.currentTarget.style.transform = "scale(1.002)";
                                                                e.currentTarget.style.boxShadow = "0 4px 12px rgba(102, 126, 234, 0.15)";
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.currentTarget.style.backgroundColor = index % 2 === 0 ? "#ffffff" : "#fafbfc";
                                                                e.currentTarget.style.transform = "scale(1)";
                                                                e.currentTarget.style.boxShadow = "none";
                                                            }}
                                                        >
                                                            {/* Checkbox */}
                                                            <td className="text-center px-3">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    style={{
                                                                        width: '18px',
                                                                        height: '18px',
                                                                        cursor: 'pointer',
                                                                        accentColor: '#667eea'
                                                                    }}
                                                                />
                                                            </td>

                                                            {/* User Info */}
                                                            <td className="px-3 py-3">
                                                                <Stack direction="row" alignItems="center" spacing={2}>

                                                                    <div>
                                                                        <Typography
                                                                            variant="subtitle2"
                                                                            sx={{
                                                                                fontWeight: 700,
                                                                                fontSize: '14px',
                                                                                color: '#1a202c',
                                                                                mb: 0.3
                                                                            }}
                                                                        ><i className="fa fa-user me-1" style={{ fontSize: '10px' }} />
                                                                            <span class="text-capitalize">{item?.name || "N/A"}</span>
                                                                        </Typography>
                                                                        <Typography
                                                                            variant="body2"
                                                                            sx={{
                                                                                color: "#6b7280",
                                                                                fontSize: 12,
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                mb: 0.3
                                                                            }}
                                                                        >
                                                                            <i className="fa fa-envelope me-1" style={{ fontSize: '10px' }} />
                                                                            {item?.email || "No Email"}
                                                                        </Typography>
                                                                        <Typography
                                                                            variant="body2"
                                                                            sx={{
                                                                                color: "#10b981",
                                                                                fontSize: 12,
                                                                                fontWeight: 600,
                                                                                display: 'flex',
                                                                                alignItems: 'center'
                                                                            }}
                                                                        >
                                                                            <Link href={`tel:${item?.phone}`} style={{ textDecoration: 'none' }}>
                                                                                <i className="fa fa-phone me-1" style={{ fontSize: '10px' }} />
                                                                                {item?.phone || "No Phone"}
                                                                            </Link>
                                                                        </Typography>
                                                                    </div>
                                                                </Stack>
                                                            </td>

                                                            {/* Lead Info */}
                                                            <td className="px-3" style={{ fontSize: 13 }}>
                                                                <div className="mb-2">
                                                                    <span
                                                                        className="badge rounded-pill px-2 py-1"
                                                                        style={{
                                                                            background: 'linear-gradient(135deg, #667eea20, #764ba220)',
                                                                            color: '#667eea',
                                                                            fontWeight: 600,
                                                                            fontSize: '11px'
                                                                        }}
                                                                    >
                                                                        ID: {item?.id || "N/A"}
                                                                    </span>
                                                                </div>
                                                                {item?.company && (
                                                                    <div className="mb-1 d-flex align-items-center">
                                                                        <i className="fa fa-building me-2" style={{ color: '#667eea', fontSize: '12px' }} />
                                                                        <span style={{ color: '#374151', fontWeight: 500 }}>{item?.company}</span>
                                                                    </div>
                                                                )}
                                                                {item?.trade_mark_for && (
                                                                    <div className="mb-1 d-flex align-items-start">
                                                                        <i className="fa fa-trademark me-2 mt-1" style={{ color: '#f59e0b', fontSize: '12px' }} />
                                                                        <span
                                                                            style={{
                                                                                color: '#6b7280',
                                                                                fontSize: '12px',
                                                                                maxWidth: '150px',
                                                                                overflow: 'hidden',
                                                                                textOverflow: 'ellipsis',
                                                                                whiteSpace: 'nowrap'
                                                                            }}
                                                                            title={item?.trade_mark_for || "N/A"}
                                                                        >
                                                                            {item?.trade_mark_for || "N/A"}
                                                                        </span>
                                                                    </div>
                                                                )}
                                                                {item?.location && (
                                                                    <div className="d-flex align-items-center mt-2">
                                                                        <i className="fa fa-map-marker-alt me-2" style={{ color: '#ef4444', fontSize: '12px' }} />
                                                                        <span className="small text-muted">{item?.location}</span>
                                                                    </div>
                                                                )}
                                                            </td>

                                                            {/* Source Info */}
                                                            <td className="px-3">
                                                                <div className="d-flex flex-column gap-1">
                                                                    <div className="d-flex align-items-center">
                                                                        <span
                                                                            className="badge rounded-pill px-2 py-1 me-2"
                                                                            style={{
                                                                                background: item?.utm_source ?
                                                                                    'linear-gradient(135deg, #8b5cf6, #6366f1)' :
                                                                                    '#e5e7eb',
                                                                                color: item?.utm_source ? '#fff' : '#6b7280',
                                                                                fontSize: '10px',
                                                                                fontWeight: 600
                                                                            }}
                                                                        >
                                                                            {item?.utm_source || "Direct"}
                                                                        </span>
                                                                    </div>
                                                                    {item?.utm_medium && (
                                                                        <div className="small" style={{ fontSize: '11px', color: '#6b7280' }}>
                                                                            <strong style={{ color: '#374151' }}>Medium:</strong> {item?.utm_medium}
                                                                        </div>
                                                                    )}
                                                                    {item?.utm_campaign && (
                                                                        <div
                                                                            className="small text-muted"
                                                                            style={{
                                                                                fontSize: '11px',
                                                                                maxWidth: '150px',
                                                                                overflow: 'hidden',
                                                                                textOverflow: 'ellipsis',
                                                                                whiteSpace: 'nowrap'
                                                                            }}
                                                                            title={item?.utm_campaign}
                                                                        >
                                                                            <i className="fa fa-bullhorn me-1" style={{ fontSize: '10px' }} />
                                                                            {item?.utm_campaign}
                                                                        </div>
                                                                    )}
                                                                    {item?.source_url ? (
                                                                        <a
                                                                            href={item?.source_url}
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                            className="badge text-decoration-none d-inline-flex align-items-center mt-1"
                                                                            style={{
                                                                                background: 'linear-gradient(135deg, #10b98120, #059669 20)',
                                                                                color: '#059669',
                                                                                fontSize: "10px",
                                                                                fontWeight: 600,
                                                                                padding: '4px 8px',
                                                                                transition: 'all 0.2s',
                                                                                width: 'fit-content'
                                                                            }}
                                                                            onMouseEnter={(e) => {
                                                                                e.currentTarget.style.background = 'linear-gradient(135deg, #10b981, #059669)';
                                                                                e.currentTarget.style.color = '#fff';
                                                                                e.currentTarget.style.transform = 'translateX(2px)';
                                                                            }}
                                                                            onMouseLeave={(e) => {
                                                                                e.currentTarget.style.background = 'linear-gradient(135deg, #10b98120, #05966920)';
                                                                                e.currentTarget.style.color = '#059669';
                                                                                e.currentTarget.style.transform = 'translateX(0)';
                                                                            }}
                                                                        >
                                                                            Visit URL <i className="fa fa-external-link-alt ms-1" style={{ fontSize: '9px' }} />
                                                                        </a>
                                                                    ) : (
                                                                        <span className="badge bg-light text-secondary border mt-1" style={{ fontSize: '10px', width: 'fit-content' }}>
                                                                            No URL
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </td>

                                                            {/* Message */}
                                                            <td className="px-3" style={{ maxWidth: "200px" }}>
                                                                <div className="position-relative">
                                                                    <Typography
                                                                        variant="body2"
                                                                        sx={{
                                                                            fontSize: 12,
                                                                            color: "#4b5563",
                                                                            lineHeight: 1.5,
                                                                            display: '-webkit-box',
                                                                            WebkitLineClamp: 2,
                                                                            WebkitBoxOrient: 'vertical',
                                                                            overflow: 'hidden',
                                                                            textOverflow: 'ellipsis',
                                                                            background: '#f9fafb',
                                                                            padding: '8px 10px',
                                                                            borderRadius: '8px',
                                                                            border: '1px solid #e5e7eb',
                                                                            fontStyle: item?.message ? 'normal' : 'italic'
                                                                        }}
                                                                        title={item?.message}
                                                                    >
                                                                        {item?.message || "No message provided"}
                                                                    </Typography>
                                                                </div>
                                                            </td>

                                                            {/* Status */}
                                                            <td className="px-3">
                                                                <span
                                                                    className={`badge rounded-pill px-3 py-2 d-inline-flex align-items-center gap-1`}
                                                                    style={{
                                                                        background: item?.stage_name === "Hot"
                                                                            ? "linear-gradient(135deg, #ef4444, #dc2626)"
                                                                            : item?.stage_name === "New"
                                                                                ? "linear-gradient(135deg, #3b82f6, #2563eb)"
                                                                                : item?.stage_name === "Warm"
                                                                                    ? "linear-gradient(135deg, #f59e0b, #d97706)"
                                                                                    : "linear-gradient(135deg, #8b5cf6, #7c3aed)",
                                                                        color: '#fff',
                                                                        fontSize: '11px',
                                                                        fontWeight: 700,
                                                                        textTransform: 'uppercase',
                                                                        letterSpacing: '0.5px',
                                                                        boxShadow: item?.stage_name === "Hot"
                                                                            ? '0 4px 10px rgba(239, 68, 68, 0.3)'
                                                                            : '0 2px 6px rgba(0,0,0,0.1)'
                                                                    }}
                                                                >
                                                                    <span
                                                                        className="rounded-circle d-inline-block"
                                                                        style={{
                                                                            width: '6px',
                                                                            height: '6px',
                                                                            background: '#fff',
                                                                            animation: item?.stage_name === "Hot" ? 'pulse 1.5s infinite' : 'none'
                                                                        }}
                                                                    />
                                                                    {item?.stage_name || "New"}
                                                                </span>
                                                            </td>

                                                            {/* Date */}
                                                            <td className="px-3">
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <div
                                                                        className="rounded d-flex align-items-center justify-content-center"
                                                                        style={{
                                                                            width: '32px',
                                                                            height: '32px',
                                                                            background: 'linear-gradient(135deg, #667eea20, #764ba220)',
                                                                            border: '1px solid #667eea40'
                                                                        }}
                                                                    >
                                                                        <i className="fa fa-calendar-alt" style={{ fontSize: '12px', color: '#667eea' }} />
                                                                    </div>
                                                                    <Typography
                                                                        variant="body2"
                                                                        sx={{
                                                                            fontWeight: 600,
                                                                            fontSize: 12,
                                                                            color: "#374151",
                                                                            lineHeight: 1.2
                                                                        }}
                                                                    >
                                                                        {item?.created_date || "—"}
                                                                    </Typography>
                                                                </div>
                                                            </td>

                                                            {/* Actions */}
                                                            <td className="text-center px-3">
                                                                <Stack direction="row" spacing={1} justifyContent="center">
                                                                    <button
                                                                        className="btn btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                                                        title="View Details"
                                                                        onClick={() => handleViewDetails(item.id)}
                                                                        style={{
                                                                            width: '36px',
                                                                            height: '36px',
                                                                            background: 'linear-gradient(135deg, #3b82f620, #2563eb20)',
                                                                            border: '1.5px solid #3b82f640',
                                                                            color: '#3b82f6',
                                                                            transition: 'all 0.2s'
                                                                        }}
                                                                        onMouseEnter={(e) => {
                                                                            e.currentTarget.style.background = 'linear-gradient(135deg, #3b82f6, #2563eb)';
                                                                            e.currentTarget.style.color = '#fff';
                                                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                                                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.3)';
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            e.currentTarget.style.background = 'linear-gradient(135deg, #3b82f620, #2563eb20)';
                                                                            e.currentTarget.style.color = '#3b82f6';
                                                                            e.currentTarget.style.transform = 'translateY(0)';
                                                                            e.currentTarget.style.boxShadow = 'none';
                                                                        }}
                                                                    >
                                                                        <i className="fa fa-eye" style={{ fontSize: '14px' }} />
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                                                        title="Edit Lead"
                                                                        style={{
                                                                            width: '36px',
                                                                            height: '36px',
                                                                            background: 'linear-gradient(135deg, #10b98120, #05966920)',
                                                                            border: '1.5px solid #10b98140',
                                                                            color: '#10b981',
                                                                            transition: 'all 0.2s'
                                                                        }}
                                                                        onMouseEnter={(e) => {
                                                                            e.currentTarget.style.background = 'linear-gradient(135deg, #10b981, #059669)';
                                                                            e.currentTarget.style.color = '#fff';
                                                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                                                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.3)';
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            e.currentTarget.style.background = 'linear-gradient(135deg, #10b98120, #05966920)';
                                                                            e.currentTarget.style.color = '#10b981';
                                                                            e.currentTarget.style.transform = 'translateY(0)';
                                                                            e.currentTarget.style.boxShadow = 'none';
                                                                        }}
                                                                    >
                                                                        <i className="fa fa-pen" style={{ fontSize: '13px' }} />
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                                                        title="Delete"
                                                                        style={{
                                                                            width: '36px',
                                                                            height: '36px',
                                                                            background: 'linear-gradient(135deg, #ef444420, #dc262620)',
                                                                            border: '1.5px solid #ef444440',
                                                                            color: '#ef4444',
                                                                            transition: 'all 0.2s'
                                                                        }}
                                                                        onMouseEnter={(e) => {
                                                                            e.currentTarget.style.background = 'linear-gradient(135deg, #ef4444, #dc2626)';
                                                                            e.currentTarget.style.color = '#fff';
                                                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                                                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(239, 68, 68, 0.3)';
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            e.currentTarget.style.background = 'linear-gradient(135deg, #ef444420, #dc262620)';
                                                                            e.currentTarget.style.color = '#ef4444';
                                                                            e.currentTarget.style.transform = 'translateY(0)';
                                                                            e.currentTarget.style.boxShadow = 'none';
                                                                        }}
                                                                    >
                                                                        <i className="fa fa-trash-alt" style={{ fontSize: '13px' }} />
                                                                    </button>
                                                                </Stack>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>


                                    </div>

                                    {/* ✅ Dynamic Pagination */}
                                    <div className="d-flex justify-content-center mt-3">
                                        <nav>
                                            <ul className="pagination mb-0">
                                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                    <button
                                                        className="page-link"
                                                        onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                                                    >
                                                        Previous
                                                    </button>
                                                </li>

                                                {/* Render page numbers */}
                                                {[...Array(totalPages)].map((_, index) => {
                                                    const pageNum = index + 1;
                                                    return (
                                                        <li
                                                            key={pageNum}
                                                            className={`page-item ${pageNum === currentPage ? "active" : ""}`}
                                                        >
                                                            <button
                                                                className="page-link"
                                                                onClick={() => setCurrentPage(pageNum)}
                                                            >
                                                                {pageNum}
                                                            </button>
                                                        </li>
                                                    );
                                                })}

                                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                                    <button
                                                        className="page-link"
                                                        onClick={() =>
                                                            currentPage < totalPages && setCurrentPage(currentPage + 1)
                                                        }
                                                    >
                                                        Next
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                    {/* View lead details drawer Start here */}
                    <Drawer
                        className='text-capitalize'
                        title={
                            selectedLead
                                ? `Lead #${selectedLead.id} – ${selectedLead.name}`
                                : 'Lead Details'
                        }
                        placement="right"
                        size={detailSize}
                        onClose={() => setDetailOpen(false)}
                        open={detailOpen}
                        bodyStyle={{
                            padding: 24,
                            background: 'linear-gradient(135deg, #f9fafb 0%, #edf2ff 100%)',
                        }}
                    >
                        {detailLoading ? (
                            // While loading, show skeleton-style placeholders
                            <div>
                                <Skeleton height={20} style={{ marginBottom: 10 }} />
                                <Skeleton height={20} style={{ marginBottom: 10 }} />
                                <Skeleton height={20} style={{ marginBottom: 10 }} />
                            </div>
                        ) : !selectedLead ? (
                            <p style={{ color: '#6b7280' }}>No details available.</p>
                        ) : (
                            <>
                                {/* Top summary section */}
                                <div
                                    style={{
                                        padding: '16px 20px',
                                        borderRadius: 12,
                                        background:
                                            'linear-gradient(135deg, rgba(59,130,246,0.1), rgba(59,130,246,0.02))',
                                        border: '1px solid rgba(59,130,246,0.18)',
                                        marginBottom: 20,
                                    }}
                                >
                                    <h3
                                        style={{
                                            margin: 0,
                                            fontSize: 20,
                                            fontWeight: 700,
                                            color: '#1f2937',
                                            textTransform: 'capitalize',
                                        }}
                                    >
                                        <i className="fa fa-user me-2" />
                                        {selectedLead.name}
                                    </h3>
                                    <p style={{ margin: '8px 0 0', color: '#6b7280', fontSize: 13 }}>
                                        <i className="fa fa-building me-1" /> {selectedLead.company || 'No company'}
                                    </p>
                                    <p style={{ margin: '4px 0 0', color: '#6b7280', fontSize: 13 }}>
                                        <i className="fa fa-map-marker me-1" /> {selectedLead.location || 'No location'}
                                    </p>
                                </div>

                                <Divider orientation="left">Contact Info</Divider>
                                <Descriptions bordered size="small" column={2}>
                                    <Descriptions.Item className="bold-label" label="Name">
                                        {selectedLead.name || '—'}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Email">
                                        {selectedLead.email || '—'}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Phone">
                                        {selectedLead.phone || '—'}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Address" span={2}>
                                        {selectedLead.address || '—'}
                                    </Descriptions.Item>
                                </Descriptions>

                                <Divider orientation="left">Trademark Details</Divider>

                                <Descriptions bordered size="small" column={2}>
                                    <Descriptions.Item label="Trademark For" span={2}>
                                        {selectedLead.trade_mark_for || '—'}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Class">
                                        {selectedLead.class || '—'}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Application Date">
                                        {selectedLead.date_of_application
                                            ? formatDate(selectedLead.date_of_application)
                                            : '—'}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Appropriate Office">
                                        {selectedLead.appropriate_office || '—'}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Country">
                                        {selectedLead.country || '—'}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="State">
                                        {selectedLead.state || '—'}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Goods & Services" span={2}>
                                        {selectedLead.goods_and_service_details || '—'}
                                    </Descriptions.Item>
                                </Descriptions>

                                <Divider orientation="left">Marketing / UTM</Divider>

                                <Descriptions bordered size="small" column={2}>
                                    <Descriptions.Item label="UTM Source">
                                        {selectedLead.utm_source ? (
                                            <Tag color="purple">{selectedLead.utm_source}</Tag>
                                        ) : (
                                            '—'
                                        )}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="UTM Medium">
                                        {selectedLead.utm_medium ? (
                                            <Tag color="blue">{selectedLead.utm_medium}</Tag>
                                        ) : (
                                            '—'
                                        )}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="UTM Campaign" span={2}>
                                        {selectedLead.utm_campaign || '—'}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Source URL" span={2}>
                                        {selectedLead.source_url ? (
                                            <a href={selectedLead.source_url} target="_blank" rel="noreferrer">
                                                {selectedLead.source_url}
                                            </a>
                                        ) : (
                                            '—'
                                        )}
                                    </Descriptions.Item>
                                </Descriptions>

                                <Divider orientation="left">System / Meta</Divider>

                                <Descriptions bordered size="small" column={2}>
                                    <Descriptions.Item label="System IP">
                                        {selectedLead.system_ip || '—'}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Created At">
                                        {selectedLead.created_at
                                            ? new Date(selectedLead.created_at).toLocaleString('en-IN')
                                            : '—'}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Updated At">
                                        {selectedLead.updated_at
                                            ? new Date(selectedLead.updated_at).toLocaleString('en-IN')
                                            : '—'}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Stage">
                                        {selectedLead.stage || '—'}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Is Positive">
                                        {selectedLead.is_positive === 1 ? (
                                            <Tag color="green">Positive</Tag>
                                        ) : (
                                            <Tag color="red">Not Positive</Tag>
                                        )}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Assign To">
                                        {selectedLead.assign_to || '—'}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Remarks" span={2}>
                                        {selectedLead.remarks || '—'}
                                    </Descriptions.Item>
                                </Descriptions>

                                <Divider orientation="left">Message</Divider>

                                <div
                                    style={{
                                        background: '#f9fafb',
                                        borderRadius: 8,
                                        padding: 12,
                                        border: '1px solid #e5e7eb',
                                        fontSize: 13,
                                        color: '#4b5563',
                                        whiteSpace: 'pre-wrap',
                                    }}
                                >
                                    {selectedLead.message || 'No message provided.'}
                                </div>
                            </>
                        )}
                    </Drawer>

                    {/* View Lead Details drawer end  */}
                </div>
            </div>
        </div>
    );
};

export default LeadInbox;
